<template>
  <div class="col-xl-12">
    <div class="card">
      <div class="card-body">
        <div class="clearfix">
          <div class="float-right">
            <div class="input-group input-group-sm">
              <select
                v-model="selected"
                @change="changeSelection"
                class="custom-select custom-select-sm"
              >
                <option>Profit</option>
                <option>Revenue</option>
                <option>Expenses</option>
              </select>
            </div>
          </div>
          <h4 class="card-title mb-4">{{ selected }}</h4>
        </div>

        <div class="row">
          <div class="col-lg-3">
            <div class="text-muted">
              <div class="mb-4">
                <p>Job #{{ jobNum }}</p>
                <h4>${{ displayTotal }}</h4>
              </div>

              <div>
                <b-button
                  @click="
                    () => {
                      viewDetails = !viewDetails;
                    }
                  "
                  variant="primary"
                  size="sm"
                >
                  View Details
                  <i class="mdi mdi-chevron-right ml-1"></i>
                </b-button>
              </div>

              <div v-if="selected === 'Profit' && viewDetails" class="mt-4">
                <div>
                  <p class="mb-2">Revenue</p>
                  <h5>${{ totalRevenue.toFixed(2) }}</h5>
                </div>
                <div>
                  <p class="mb-2">Expenses</p>
                  <h5>${{ totalExpenses.toFixed(2) }}</h5>
                </div>
              </div>
              <div v-if="selected === 'Revenue' && viewDetails" class="mt-4">
                <div class="mb-3">
                  <p style="display:inline">
                    Labour:
                  </p>
                  <h6 style="display:inline">
                    ${{ payrollRevenue.toFixed(2) }}
                  </h6>
                </div>
                <div class="mb-3">
                  <p style="display:inline">
                    Products:
                  </p>
                  <h6 style="display:inline">
                    ${{ productRevenue.toFixed(2) }}
                  </h6>
                </div>
                <div>
                  <p style="display:inline">Procurement:</p>
                  <h6 style="display:inline">
                    ${{ procurementRevenue.toFixed(2) }}
                  </h6>
                  <div class="mt-1">
                    <p style="display:inline" class="mb-3 ml-3">Materials:</p>
                    <h6 style="display:inline">
                      ${{ procurementRevenueBreakdown.Materials.toFixed(2) }}
                    </h6>
                  </div>
                  <div class="mt-1">
                    <p style="display:inline" class="mb-3 ml-3">Rentals:</p>
                    <h6 style="display:inline">
                      ${{ procurementRevenueBreakdown.Rentals.toFixed(2) }}
                    </h6>
                  </div>
                  <div class="mt-1">
                    <p style="display:inline" class="mb-3 ml-3">3rd Party:</p>
                    <h6 style="display:inline">
                      ${{ procurementRevenueBreakdown['3rd Party'].toFixed(2) }}
                    </h6>
                  </div>
                  <div class="mt-1">
                    <p style="display:inline" class="mb-3 ml-3">Other:</p>
                    <h6 style="display:inline">
                      ${{ procurementRevenueBreakdown.Other.toFixed(2) }}
                    </h6>
                  </div>
                </div>
              </div>
              <div v-if="selected === 'Expenses' && viewDetails" class="mt-4">
                <div class="mb-3">
                  <p style="display:inline">
                    Payroll:
                  </p>
                  <h6 style="display:inline">
                    ${{ payrollExpenses.toFixed(2) }}
                  </h6>
                </div>
                <div class="mb-3">
                  <h6 style="display:inline">
                    Products:
                  </h6>
                  <h6 style="display:inline">
                    ${{ productExpenses.toFixed(2) }}
                  </h6>
                </div>
                <div>
                  <p style="display:inline">Procurement:</p>
                  <h6 style="display:inline">
                    ${{ procurementExpenses.toFixed(2) }}
                  </h6>
                  <div class="mt-1">
                    <p style="display:inline" class="mb-3 ml-3">Materials:</p>
                    <h6 style="display:inline">
                      ${{ procurementExpensesBreakdown.Materials.toFixed(2) }}
                    </h6>
                  </div>
                  <div class="mt-1">
                    <p style="display:inline" class="mb-3 ml-3">Rentals:</p>
                    <h6 style="display:inline">
                      ${{ procurementExpensesBreakdown.Rentals.toFixed(2) }}
                    </h6>
                  </div>
                  <div class="mt-1">
                    <p style="display:inline" class="mb-3 ml-3">3rd Party:</p>
                    <h6 style="display:inline">
                      ${{
                        procurementExpensesBreakdown['3rd Party'].toFixed(2)
                      }}
                    </h6>
                  </div>
                  <div class="mt-1">
                    <p style="display:inline" class="mb-3 ml-3">Other:</p>
                    <h6 style="display:inline">
                      ${{ procurementExpensesBreakdown.Other.toFixed(2) }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <apexchart
              class="apex-charts"
              dir="ltr"
              height="320"
              :series="earningLineChart.series"
              :options="earningLineChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import moment from 'moment';

export default {
  data() {
    return {
      earningLineChart: {
        series: [
          {
            name: '',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 320,
            type: 'line',
            toolbar: 'false',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 8,
              opacity: 0.2,
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#556ee6'],
          stroke: {
            curve: 'smooth',
            width: 3,
          },
        },
      },
      billableTimes: [],
      billableProducts: [],
      allProcurements: [],
      billableProcurements: [],

      payrollExpenses: null,
      productExpenses: null,
      procurementExpenses: null,
      totalExpenses: null,

      payrollRevenue: null,
      productRevenue: null,
      procurementRevenue: null,
      totalRevenue: null,

      procurementRevenueBreakdown: {
        Materials: 0,
        Rentals: 0,
        '3rd Party': 0,
        Other: 0,
      },
      procurementExpensesBreakdown: {
        Materials: 0,
        Rentals: 0,
        '3rd Party': 0,
        Other: 0,
      },

      graphRevenue: [],
      graphExpenses: [],
      graphIncome: [],
      //the difference between graphRevenue and revenue, etc, is that in graphRevenue the y value is summed based on the previous index, while revenue is just the value
      revenue: [],
      expenses: [],
      income: [],

      selected: 'Profit',
      viewDetails: false,
    };
  },
  props: {
    jobNum: Number,
    allTimes: Array,
    allProducts: Array,
    jobType: String,
    jobQuote: String,
    jobDate: String,
  },

  methods: {
    changeSelection: function() {
      this.viewDetails = false;
      if (this.selected === 'Profit') {
        this.earningLineChart.series = [
          { name: 'Profit', data: this.graphIncome },
        ];
      } else if (this.selected === 'Expenses') {
        this.earningLineChart.series = [
          { name: 'Expenses', data: this.graphExpenses },
        ];
      } else if (this.selected === 'Revenue') {
        this.earningLineChart.series = [
          { name: 'Revenue', data: this.graphRevenue },
        ];
      }
    },
    getProcurements: async function() {
      try {
        let db = firebase.firestore();
        let procurementsRef = db
          .collection('procurements')
          .where('org', '==', sessionStorage.getItem('org'))
          .where('jobNum', '==', this.jobNum);
        let allProcurementsTemp = await procurementsRef.get();
        for (const doc of allProcurementsTemp.docs) {
          this.allProcurements.push(doc.data());
        }
      } catch (error) {
        console.log(error);
      }
    },

    //this function adds up all the expenses(payroll products and procurements) and collects the data for the graph
    //it does this by getting a list of user ids who worked this job, and adding those to an object with the user id as the key
    //it then loops over the billable times and inserts the users payroll or overtime rate
    getTotalExpenses: async function() {
      let numberToAdd;
      this.payrollExpenses = 0;
      this.productExpenses = 0;
      this.procurementExpenses = 0;
      this.totalExpenses = 0;
      const uniqueUsers = new Set();
      let userRates = {};
      let promises = [];
      this.allTimes.forEach((time) => {
        uniqueUsers.add(time.uid);
      });
      uniqueUsers.forEach((user) => {
        try {
          let db = firebase.firestore();
          let page = db.collection('employees').doc(user);
          promises.push(
            page.get().then((doc) => {
              userRates[user] = {
                uid: user,
                payrollRate: doc.data().payrollRate,
                payrollOvertimeRate: doc.data().payrollOvertimeRate,
                payrollTravelRate: doc.data().travelTimeRate
                  ? doc.data().travelTimeRate
                  : null,
              };
            })
          );
        } catch (error) {
          console.log('ERROR', error);
        }
      });
      await Promise.all(promises).then(() => {
        this.allTimes.forEach((time) => {
          if (time.overtime) {
            numberToAdd =
              Number(time.hours) *
              Number(
                userRates[time.uid].payrollOvertimeRate != null
                  ? userRates[time.uid].payrollOvertimeRate
                  : userRates[time.uid].payrollRate
              );

            this.payrollExpenses += numberToAdd;
          } else if (time.travelTime) {
            numberToAdd =
              Number(time.hours) *
              Number(
                userRates[time.uid].payrollTravelRate != null
                  ? userRates[time.uid].payrollTravelRate
                  : userRates[time.uid].payrollRate
              ); //if the user does not have a travel rate, then just use their regular rate for the calculation.

            this.payrollExpenses += numberToAdd;
          } else {
            numberToAdd =
              Number(time.hours) * Number(userRates[time.uid].payrollRate);

            this.payrollExpenses += numberToAdd;
          }
          this.graphExpenses.push({
            x: moment(time.date).format('MM[/]DD[/]YYYY'),
            y: numberToAdd,
          });
        });
      });

      this.allProcurements.forEach((procurement) => {
        numberToAdd = Number(
          procurement.receivedAmount
            ? procurement.receivedAmount
            : procurement.quotedAmount
        );

        this.procurementExpenses += numberToAdd;
        this.procurementExpensesBreakdown[procurement.type] += numberToAdd;

        this.graphExpenses.push({
          x: moment(Date(procurement.date)).format('MM[/]DD[/]YYYY'),
          y: numberToAdd,
        });
      });

      this.allProducts.forEach((product) => {
        numberToAdd = Number(
          product.price ? product.price * product.quantity : 0
        );

        this.productExpenses += numberToAdd;

        this.graphExpenses.push({
          x: moment(Date(product.date)).format('MM[/]DD[/]YYYY'),
          y: numberToAdd,
        });
      });
      this.totalExpenses =
        this.payrollExpenses + this.productExpenses + this.procurementExpenses;

      let expensesSummary = {
        labour: this.payrollExpenses,
        procurements: this.procurementExpensesBreakdown,
        products: this.productExpenses,
      };

      this.$emit('expensesCalculated', expensesSummary, this.totalExpenses);
    },

    //this function adds up all the revenue and collects the data for the graph
    getTotalRevenue: function() {
      let numberToAdd;
      this.payrollRevenue = 0;
      this.productRevenue = 0;
      this.procurementRevenue = 0;
      this.totalRevenue = 0;
      this.billableTimes.forEach((time) => {
        this.payrollRevenue += Number(time.rate) * Number(time.hours);
        this.graphRevenue.push({
          x: moment(time.date).format('MM[/]DD[/]YYYY'),
          y: Number(time.rate) * Number(time.hours),
        });
      });
      this.billableProducts.forEach((product) => {
        this.productRevenue += Number(product.quantity) * Number(product.rate);
        this.graphRevenue.push({
          x: moment(product.date).format('MM[/]DD[/]YYYY'),
          y: Number(product.quantity) * Number(product.rate),
        });
      });
      this.billableProcurements.forEach((procurement) => {
        //only sum the procurement amounts to revenue if it has a received amount.
        if (procurement.receivedAmount) {
          if (
            procurement.markup !== null &&
            procurement.markup !== undefined &&
            procurement.markup !== ''
          ) {
            if (procurement.markupType === 'flatRate') {
              numberToAdd = Number(procurement.markup);

              this.procurementRevenue += numberToAdd;

              this.procurementRevenueBreakdown[procurement.type] += numberToAdd;
            } else if (procurement.markupType === 'percentage') {
              numberToAdd =
                Number(procurement.receivedAmount) *
                  (Number(procurement.markup) / 100) +
                Number(procurement.receivedAmount);

              this.procurementRevenue += numberToAdd;

              this.procurementRevenueBreakdown[procurement.type] += numberToAdd;
            } else if (procurement.markupType === 'dollar') {
              numberToAdd =
                Number(procurement.receivedAmount) + Number(procurement.markup);

              this.procurementRevenue += numberToAdd;

              this.procurementRevenueBreakdown[procurement.type] += numberToAdd;
            }
          } else {
            numberToAdd = Number(procurement.receivedAmount);

            this.procurementRevenue += numberToAdd;

            this.procurementRevenueBreakdown[procurement.type] += numberToAdd;
          }
          this.graphRevenue.push({
            x: moment(Date(procurement.date)).format('MM[/]DD[/]YYYY'),
            y: numberToAdd,
          });
        }
      });
      this.totalRevenue =
        this.payrollRevenue + this.productRevenue + this.procurementRevenue;

      let revenueSummary = {
        labour: this.payrollRevenue,
        products: this.productRevenue,
        procurements: this.procurementRevenueBreakdown,
      };
      //emit the revenue object back to the parent
      this.$emit(
        'revenueCalculated',
        revenueSummary,
        this.totalRevenue,
        this.jobNum
      );
      if (this.jobType === 'Quoted (Fixed Rate)') {
        this.payrollRevenue = 0;
        this.productRevenue = 0;
        this.procurementRevenue = 0;
        this.totalRevenue = Number(this.jobQuote);
        this.graphRevenue = [];
      }
    },
    //filters the times, products, and procurements, to get only the billable ones
    getBillableItems: function() {
      this.allTimes.sort((a, b) => new Date(a.date) - new Date(b.date));
      this.allProducts.sort((a, b) => new Date(a.date) - new Date(b.date));
      this.allProcurements.sort((a, b) => new Date(a.date) - new Date(b.date));

      this.billableTimes = this.allTimes.filter(
        (time) => time.billable !== true
      );

      this.billableProducts = this.allProducts.filter(
        (product) => product.billable !== true
      );

      this.billableProcurements = this.allProcurements.filter((procurement) => {
        if (procurement.billable) {
          return procurement.billable.value !== true;
        } else {
          return true;
        }
      });
    },

    //takes the collected data and combines it into common dates and turns it into a form that the graph can use
    calculateGraphRevenue: function() {
      if (this.jobType === 'Quoted (Fixed Rate)') {
        this.graphRevenue[0] = {
          x: moment(this.jobDate).format('MM[/]DD[/]YYYY'),
          y: Number(this.jobQuote),
        };
        this.revenue[0] = {
          x: moment(this.jobDate).format('MM[/]DD[/]YYYY'),
          y: Number(this.jobQuote),
        };
      } else {
        //first gets a set of unique dates(no duplicates)
        const uniqueDates = new Set();
        this.graphRevenue.forEach((revenue) => {
          uniqueDates.add(revenue.x);
        });
        let graphRevenueFinal = [];
        uniqueDates.forEach((date) => {
          graphRevenueFinal.push({ x: date, y: 0 });
        });
        //then adds every value that shares the same date
        this.graphRevenue.forEach((revenue) => {
          let index = graphRevenueFinal.findIndex((e) => e.x === revenue.x);
          graphRevenueFinal[index].y += Number(revenue.y.toFixed(2));
        });
        //next it sorts and then sums the y values based on the preceding y value for the graph
        graphRevenueFinal.sort((a, b) => new Date(a.x) - new Date(b.x));
        this.revenue = JSON.parse(JSON.stringify(graphRevenueFinal));

        graphRevenueFinal.forEach((date, index) => {
          if (index > 0) {
            date.y += graphRevenueFinal[index - 1].y;
          }
        });
        this.graphRevenue = graphRevenueFinal;
      }
    },

    //takes the collected data and combines it into common dates and turns it into a form that the graph can use
    calculateGraphExpenses: function() {
      //first gets a set of unique dates(no duplicates)

      const uniqueDates = new Set();
      this.graphExpenses.forEach((expenses) => {
        uniqueDates.add(expenses.x);
      });
      let graphExpensesFinal = [];
      uniqueDates.forEach((date) => {
        graphExpensesFinal.push({ x: date, y: 0 });
      });
      //then adds every value that shares the same date

      this.graphExpenses.forEach((expenses) => {
        let index = graphExpensesFinal.findIndex((e) => e.x === expenses.x);
        graphExpensesFinal[index].y += Number(expenses.y.toFixed(2));
      });
      //next it sorts and then sums the y values based on the preceding y value for the graph

      graphExpensesFinal.sort((a, b) => new Date(a.x) - new Date(b.x));

      this.expenses = JSON.parse(JSON.stringify(graphExpensesFinal));

      graphExpensesFinal.forEach((date, index) => {
        if (index > 0) {
          date.y += graphExpensesFinal[index - 1].y;
        }
      });

      this.graphExpenses = graphExpensesFinal;
    },

    //loops over both the expenses and the revenue and determines the income graph
    calculateGraphIncome: function() {
      let flag = false;
      let expensesCopy = JSON.parse(JSON.stringify(this.expenses));
      //goes over every expense for every revenue, if the date is the same, subtracts the expense from the revenue and pushes to graphIncome,while removing the expense
      this.revenue.forEach((revenue) => {
        for (let i = expensesCopy.length - 1; i >= 0; i--) {
          if (revenue.x === expensesCopy[i].x) {
            this.graphIncome.push({
              x: revenue.x,
              y: revenue.y - expensesCopy[i].y,
            });

            flag = true;
            expensesCopy.splice(i, 1);
          }
        }
        //if no dates match, just pushes the revenue
        if (!flag) {
          this.graphIncome.push({ x: revenue.x, y: revenue.y });
        }
        flag = false;
      });
      //pushes all remaining expenses(those whose dates didnt match)
      if (expensesCopy.length > 0) {
        expensesCopy.forEach((expense) => {
          this.graphIncome.push({ x: expense.x, y: -expense.y });
        });
      }
      //next it sorts and then sums the y values based on the preceding y value for the graph

      this.graphIncome.sort((a, b) => new Date(a.x) - new Date(b.x));

      this.income = JSON.parse(JSON.stringify(this.graphIncome));
      this.graphIncome.forEach((income, index) => {
        if (index > 0) {
          income.y = this.graphIncome[index - 1].y + this.income[index].y;
        }
      });
      this.earningLineChart.series = [
        { name: 'Profit', data: this.graphIncome },
      ];
    },
  },
  computed: {
    displayTotal() {
      if (this.selected === 'Profit') {
        return (this.totalRevenue - this.totalExpenses).toFixed(2);
      } else if (this.selected === 'Revenue') {
        return this.totalRevenue.toFixed(2);
      } else if (this.selected === 'Expenses') {
        return this.totalExpenses.toFixed(2);
      }
      return 0;
    },
  },
  async mounted() {
    await this.getProcurements();
    this.getBillableItems();
    await this.getTotalExpenses();
    this.getTotalRevenue();
    this.calculateGraphRevenue();
    this.calculateGraphExpenses();
    this.calculateGraphIncome();
  },
};
</script>
